import React from 'react';
import './HistorySidebar.css';

const HistorySidebar = ({ 
  isOpen, 
  onToggle, 
  conversations, 
  onSelectConversation, 
  activeConversationId,
  models,
  selectedModel,
  onDeleteConversation
}) => {
  const getCurrentModelConversations = () => {
    // 只返回当前选中模型的对话
    const modelConversations = conversations[selectedModel] || [];
    return modelConversations.sort((a, b) => b.timestamp - a.timestamp);
  };

  const getModelInfo = (modelValue) => {
    const model = models.find(m => m.value === modelValue);
    return model || { label: modelValue, icon: null };
  };

  const handleClearHistory = () => {
    if (window.confirm('确定要清空当前模型的所有对话记录吗？此操作不可恢复。')) {
      // 删除当前模型的所有对话
      const modelValue = selectedModel;
      onDeleteConversation(modelValue, null); // null 表示删除所有对话
    }
  };

  const handleExport = (conversation = null) => {
    let exportContent = '';
    const modelInfo = getModelInfo(selectedModel);
    
    if (conversation) {
      // 导出单个对话
      exportContent += `\n==================== ${modelInfo.label} ====================\n\n`;
      exportContent += `对话时间: ${new Date(conversation.timestamp).toLocaleString()}\n`;
      exportContent += `标题: ${conversation.title || '新对话'}\n\n`;
      
      conversation.messages.forEach((msg, index) => {
        if (index > 0) {
          exportContent += '\n- - - - - - - - - - - - - - - -\n\n';
        }
        exportContent += `${msg.role === 'user' ? '用户' : '助手'}:\n${msg.content}\n`;
      });
    } else {
      // 导出所有对话
      const modelConversations = getCurrentModelConversations();
      exportContent += `\n==================== ${modelInfo.label} ====================\n\n`;
      
      modelConversations.forEach(conv => {
        exportContent += `对话时间: ${new Date(conv.timestamp).toLocaleString()}\n`;
        exportContent += `标题: ${conv.title || '新对话'}\n\n`;
        
        conv.messages.forEach((msg, index) => {
          if (index > 0) {
            exportContent += '\n- - - - - - - - - - - - - - - -\n\n';
          }
          exportContent += `${msg.role === 'user' ? '用户' : '助手'}:\n${msg.content}\n`;
        });
        
        exportContent += '\n========================================\n\n';
      });
    }

    // 创建并下载文件
    const blob = new Blob([exportContent], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    const fileName = conversation 
      ? `对话记录_${modelInfo.label}_${new Date(conversation.timestamp).toLocaleDateString()}.txt`
      : `对话历史记录_${modelInfo.label}_${new Date().toLocaleDateString()}.txt`;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleDelete = (e, conversationId) => {
    e.stopPropagation(); // 阻止事件冒泡，避免触发对话选择
    if (window.confirm('确定要删除这个对话吗？此操作不可恢复。')) {
      onDeleteConversation(selectedModel, conversationId);
    }
  };

  return (
    <div className={`HistorySidebar ${isOpen ? 'open' : ''}`}>
      <button className="ToggleButton" onClick={onToggle}>
        {isOpen ? '›' : '‹'}
      </button>
      <div className="HistoryContent">
        <div className="HistoryHeader">
          <h3>历史对话</h3>
          <div className="HistoryActions">
            <button 
              className="ExportButton" 
              onClick={() => handleExport()}
              title="导出所有对话记录"
            >
              📥
            </button>
            <button 
              className="ClearHistoryButton" 
              onClick={handleClearHistory}
              title="清空当前模型的所有对话"
            >
              🗑️
            </button>
          </div>
        </div>
        <div className="ConversationList">
          {getCurrentModelConversations().map((conv) => (
            <div
              key={conv.id}
              className={`ConversationItem ${
                activeConversationId[selectedModel] === conv.id ? 'active' : ''
              }`}
              onClick={() => onSelectConversation(selectedModel, conv.id)}
            >
              <div className="ConversationTitle">
                {(() => {
                  const modelInfo = getModelInfo(selectedModel);
                  return (
                    <>
                      <span className="ModelBadge">
                        {modelInfo.icon && (
                          <img 
                            src={modelInfo.icon} 
                            alt={modelInfo.label}
                            className="model-icon-img"
                            style={{
                              width: '16px',
                              height: '16px',
                              marginRight: '4px',
                              verticalAlign: 'middle'
                            }}
                          />
                        )}
                        {modelInfo.label}
                      </span>
                      {conv.title || '新对话'}
                    </>
                  );
                })()}
                <div className="conversation-actions">
                  <button
                    className="export-conversation-button"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleExport(conv);
                    }}
                    title="导出对话"
                  >
                    📥
                  </button>
                  <button
                    className="delete-conversation-button"
                    onClick={(e) => handleDelete(e, conv.id)}
                    title="删除对话"
                  >
                    ✕
                  </button>
                </div>
              </div>
              <div className="ConversationMessages">
                {conv.messages.map((msg, index) => (
                  <div 
                    key={index} 
                    className={`MessagePreview ${msg.role}`}
                  >
                    {msg.role === 'user' ? '👤' : '🤖'} {msg.content.slice(0, 50)}...
                  </div>
                ))}
              </div>
              <div className="ConversationDate">
                {new Date(conv.timestamp).toLocaleString()}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HistorySidebar;